import { memo } from "react";
import {
  Card,
  CardContent,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import { CheckCircle2 } from "lucide-react";
import { isNull } from "lodash";

const LoanSummaryTable = memo(({ loanData, sx }) => {
  if (!loanData || Object.keys(loanData).length === 0) return null;

  const buildRow = (label, rawValue, formatter = (v) => v) => ({
    label,
    value: rawValue == null ? null : formatter(rawValue),
  });

  const rows = [
    buildRow("Financier", loanData.financier),
    buildRow("CIBIL Score", loanData.cibilScore),
    buildRow(
      "Invoice Value",
      loanData.invoiceValue ?? loanData.invoiceAmount,
      (v) => `₹${v.toLocaleString("en-IN")}`,
    ),
    buildRow(
      "Loan Amount",
      loanData.loanAmount,
      (v) => `₹${v.toLocaleString("en-IN")}`,
    ),
    buildRow(
      "Down Payment",
      loanData.downPayment,
      (v) => `₹${v.toLocaleString("en-IN")}`,
    ),
    buildRow("Battery Type", loanData.batteryType),
    buildRow("Tenure", loanData.tenure, (v) => `${v} months`),
    buildRow(
      "Interest Rate",
      loanData.interestRate,
      (v) => `${(v * 100).toFixed(2)}%`,
    ),
    buildRow(
      "Monthly Interest Rate",
      loanData.monthlyInterestRate,
      (v) => `${(v * 100).toFixed(2)}%`,
    ),
    buildRow(
      "Processing Fee",
      loanData.processingFee,
      (v) => `₹${v.toLocaleString("en-IN")}`,
    ),
    buildRow(
      "Insurance",
      loanData.insurance,
      (v) => `₹${v.toLocaleString("en-IN")}`,
    ),
    buildRow(
      "GST on Insurance",
      loanData.gstOnInsurance,
      (v) => `₹${v.toLocaleString("en-IN")}`,
    ),
  ];

  return (
    <Card sx={{ mb: 3, border: "1px solid #e5e7eb", ...sx }}>
      <CardContent>
        <Typography
          variant="body2"
          sx={{
            fontWeight: 700,
            color: "#1f2937",
            mb: 2,
            fontSize: "16px",
            display: "flex",
            alignItems: "center",
            gap: 1,
          }}
        >
          <CheckCircle2 style={{ fontSize: "20px", color: "#059669" }} />
          Loan Calculation Summary
        </Typography>

        <TableContainer>
          <Table size="small" sx={{ tableLayout: { xs: "fixed", sm: "auto" }, "& .MuiTableCell-root": { overflowWrap: "anywhere", px: { xs: 1, sm: 2 } } }}>
            <TableHead>
              <TableRow sx={{ backgroundColor: "#f9fafb" }}>
                <TableCell sx={{ fontWeight: 600, color: "#6b7280" }}>
                  Parameter
                </TableCell>
                <TableCell
                  sx={{ fontWeight: 600, color: "#6b7280" }}
                  align="right"
                >
                  Value
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {rows
                .filter((row) => row.value !== null && row.value !== undefined)
                .map((row) => (
                  <TableRow key={row.label} hover>
                    <TableCell sx={{ color: "#6b7280", fontSize: "0.9rem" }}>
                      {row.label}
                    </TableCell>
                    <TableCell
                      align="right"
                      sx={{
                        fontWeight: 600,
                        color: "#1f2937",
                        fontSize: "0.9rem",
                      }}
                    >
                      {row.value}
                    </TableCell>
                  </TableRow>
                ))}
            </TableBody>
          </Table>
        </TableContainer>
      </CardContent>
    </Card>
  );
});

export default LoanSummaryTable;